
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import UserModule from '@/store/modules/user';

@Component({
  components: {
  }
})
export default class RewardContactModal extends Vue {
  @Prop({ default: '' }) rewardName!: string;
  name = 'RewardContactModal';

  formModel: {
    building: string | undefined;
    streetAddress: string | undefined;
    city: string | undefined;
    zipCode: string | undefined;
    phoneNumber: string | undefined;
  }

  data() {
    return {
      formModel: {
        building: null,
        streetAddress: null,
        city: null,
        zipCode: null,
        phoneNumber: null
      }
    }
  }

  @Emit('close')
  async handleSubmit(formModel) {
    const loader = this.$loading.show();
    try {
      await UserModule.submitClaimRewardRequest({ ...formModel, rewardName: this.rewardName } as ClaimRewardRequest);
      this.$toasted.success('Your reward request has been submitted.');
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error('There was an issue submitting your request. Please try again.');
    } finally {
      loader.hide();
    }
  }
}
